import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useFormContext } from "react-hook-form";
import { Input } from "../../../Input";

const AbbottAdditionalInfoSection = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const abbottErrors = (errors as any)?.abbottAdditionalInfo ?? {};

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle1" fontWeight={600} color="#4B465C">
        Informações adicionais
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "row", gap: 2, flexWrap: "wrap" }}>
        <Box sx={{ flex: "1 1 200px", minWidth: 180 }}>
          <Input label="ID Contrato" {...register("abbottAdditionalInfo.contractId")} />
        </Box>
        <Box sx={{ flex: "1 1 200px", minWidth: 180 }}>
          <Input
            label="ID CVENT"
            {...register("abbottAdditionalInfo.cventCode")}
          />
        </Box>
      </Box>

      <Input
        label="Observações"
        multiline
        minRows={3}
        {...register("abbottAdditionalInfo.observations")}
      />

      <Typography variant="body2" fontWeight={600} color="#4B465C">
        Coordenação terrestre
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "row", gap: 2, flexWrap: "wrap" }}>
        <Box sx={{ flex: "1 1 220px", minWidth: 180 }}>
          <Input
            label="Coord.Terrestre"
            {...register("abbottAdditionalInfo.terrestrialCoordinator")}
          />
        </Box>
        <Box sx={{ flex: "1 1 160px", minWidth: 140 }}>
          <Input
            label="Fone"
            {...register("abbottAdditionalInfo.terrestrialPhone")}
          />
        </Box>
        <Box sx={{ flex: "1 1 220px", minWidth: 180 }}>
          <Input
            label="E-mail"
            type="email"
            error={!!abbottErrors.terrestrialEmail}
            helperText={abbottErrors.terrestrialEmail?.message as string}
            {...register("abbottAdditionalInfo.terrestrialEmail", {
              validate: (value) => {
                if (!value || String(value).trim() === "") return true;
                return (
                  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value)) ||
                  "Informe um e-mail válido."
                );
              },
            })}
          />
        </Box>
      </Box>

      <Typography variant="body2" fontWeight={600} color="#4B465C">
        Coordenação aérea
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "row", gap: 2, flexWrap: "wrap" }}>
        <Box sx={{ flex: "1 1 220px", minWidth: 180 }}>
          <Input
            label="Coord.Aéreo"
            {...register("abbottAdditionalInfo.aerialCoordinator")}
          />
        </Box>
        <Box sx={{ flex: "1 1 160px", minWidth: 140 }}>
          <Input label="Fone" {...register("abbottAdditionalInfo.aerialPhone")} />
        </Box>
        <Box sx={{ flex: "1 1 220px", minWidth: 180 }}>
          <Input
            label="E-mail"
            type="email"
            error={!!abbottErrors.aerialEmail}
            helperText={abbottErrors.aerialEmail?.message as string}
            {...register("abbottAdditionalInfo.aerialEmail", {
              validate: (value) => {
                if (!value || String(value).trim() === "") return true;
                return (
                  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value)) ||
                  "Informe um e-mail válido."
                );
              },
            })}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default AbbottAdditionalInfoSection;
